<template>
    <div class="lead-generation-block">
        <h3>{{ blockConfiguration.title }}</h3>

        <div class="settings-row">
            <div v-for="column in blockConfiguration.columns" :key="column.id" class="settings-column">
                <ds-card v-for="card in column.cards" :key="card.id">
                    <ds-card-body v-if="leadSourceCount > 50000">
                        <ds-list-item
                            v-for="(entry, entryIndex) in card.entries"
                            :key="entry.title"
                            :title="entry.title"
                            :description="entry.description"
                            :border-style="borderStyle(entryIndex, card.entries.length)"
                            :as="entryAction(entry.action)"
                            data-qa="card-item"
                            clickable
                            @click="handleAction(entry.action, entry.title)"
                        >
                            <template #leading>
                                <ds-icon :name="entry.icon" />
                            </template>

                            <template #trailing>
                                <ds-icon name="chevron-right" />
                            </template>
                        </ds-list-item>
                    </ds-card-body>
                    <ds-card-body v-else>
                        <ds-list-item
                            v-for="(entry, entryIndex) in card.entries"
                            :key="entry.title"
                            :title="entry.title"
                            :href="entry.link"
                            :description="entry.description"
                            :border-style="borderStyle(entryIndex, card.entries.length)"
                            :as="entryAction(entry.action)"
                            data-qa="card-item"
                            clickable
                            @click="handleAction(entry.action, entry.title)"
                        >
                            <template #leading>
                                <ds-icon :name="entry.icon" />
                            </template>

                            <template #trailing>
                                <ds-icon name="chevron-right" />
                            </template>
                        </ds-list-item>
                    </ds-card-body>

                    <ds-card-footer>
                        <ds-text-button
                            as="a"
                            :href="card.link"
                            data-qa="card-footer"
                            target="_blank"
                            trailing-icon="external-link"
                        >
                            <div>
                                {{ card.footer }}
                            </div>
                        </ds-text-button>
                    </ds-card-footer>
                </ds-card>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        blockConfiguration: Object,
        visitorSearchLink: String,
        leadSourceSearchLink: String,
        leadSourceEffectivenessReportLink: String,
        leadSourceReportLink: String,
        leadSourceCategoryReportLink: String,
        leadSourceCount: String,
    },

    methods: {
        openLink(url) {
            window.open(url, '_self');
        },

        handleAction(action, title) {
            if (title === 'Create Lead Source' && this.leadSourceCount > 50000) {
                this.$root.$emit('WARNING_LEAD_SOURCE', true);
            }

            if (action === 'trackingCode') {
                this.$root.$emit('TRACKING_CODE_MODEL');
            } else if (action === 'visitorReport') {
                this.openLink(this.visitorSearchLink);
            } else if (action === 'leadSourceSearchLink') {
                this.openLink(this.leadSourceSearchLink);
            } else if (action === 'leadSourceEffectivenessReportLink') {
                this.openLink(this.leadSourceEffectivenessReportLink);
            } else if (action === 'leadSourceReportLink') {
                this.openLink(this.leadSourceReportLink);
            } else if (action === 'leadSourceCategoryReportLink') {
                this.openLink(this.leadSourceCategoryReportLink);
            }
        },

        entryAction(action) {
            return action === 'link' ? 'a' : 'div';
        },

        borderStyle(entryIndex, entryLength) {
            return entryIndex === (entryLength - 1) ? 'none' : 'full';
        },
    },
};
</script>

<style lang="scss" scoped>
.lead-generation-block {
    margin: 0;
}

h3 {
    margin-bottom: 14px;
    line-height: 1.3;
}

.settings-row {
    display: inline-flex;
    flex-wrap: wrap;
}

.settings-column {
    padding: 4px;
}

.ds-card {
    width: 312px;
    height: fit-content;
    margin-bottom: 32px;
}

.ds-card-footer {
    text-align: center;
}

.ds-card-body {
    padding: 0;
}

.ds-card-body .list-item {
    padding: 16px;
}

.list-item > .leading-slot {
    min-width:  40px;
    padding:    14px 0 0 0;
}

.list-item-info > .trailing-slot {
    margin:         0;
    padding-top:    14px;
    --icon-color:   rgba(0, 0, 0, 0.29);
}

.item-text > .title {
    padding:        3px 0;
    color:          rgba(0, 0, 0, 0.82);
    font-weight:    normal;
}

.item-text > .description {
    -webkit-line-clamp: 3;
    color:              rgba(0, 0, 0, 0.6);
}
</style>
